import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { MasterCategoryConst, type MasterCategoryType, type MasterSearchFilters } from '../../../types/masterSearchTypes';
import { useClientMasterSearch } from '../../../hooks/useClientMasterSearch';
import { MasterSearchForm } from '../../../components/admin/MasterReference/MasterSearchForm';
import { MasterDataTable } from '../../../components/admin/MasterReference/MasterDataTable';

const MasterReferencePage = () => {
  const { currentUser } = useAuth();
  
  const [selectedCategory, setSelectedCategory] = useState<MasterCategoryType>(MasterCategoryConst.SELLER);
  const [filters, setFilters] = useState<MasterSearchFilters>({ code: '', name: '' });

  const { data, isLoading, error } = useClientMasterSearch(
    selectedCategory, 
    filters,
    !!currentUser
  );

  const handleCategoryChange = (category: MasterCategoryType) => {
    setSelectedCategory(category);
    setFilters({ code: '', name: '' });
  };

  const handleSearch = (newFilters: MasterSearchFilters) => {
    setFilters(newFilters);
  };

  if (error) {
    return <div className="p-6 text-red-600">データの取得に失敗しました。</div>;
  }

  return (
    // 画面全体を制御するコンテナ。
    // min-h-screenにより背景色を維持しつつ、flex-colで子要素の配置を制御
    <div className="p-6 space-y-4 bg-gray-50 min-h-screen flex flex-col">
      <div className="flex items-center gap-2 mb-2 flex-shrink-0">
        <h1 className="text-xl font-bold text-gray-800">マスタ情報照会</h1>
      </div>

      <div className="flex-shrink-0">
        <MasterSearchForm 
          currentCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
          onSearch={handleSearch}
        />
      </div>

      {/* テーブルコンテナ。
        flex-1により「画面の残りの高さ」を提供
        中身が小さい時は縮めるために、親要素に過度な制限（h-screenなど）をかけすぎない
      */}
      <div className="flex-1">
        <MasterDataTable 
          category={selectedCategory}
          data={data || []}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default MasterReferencePage;